import {Component, Input, OnInit} from '@angular/core';
import {AboutUsComponent} from "../legal/about-us/about-us.component";
import {TermsOfUseComponent} from "../legal/terms-of-use/terms-of-use.component";
import {ContactUsComponent} from "../legal/contact-us/contact-us.component";
import {MatDialog} from "@angular/material/dialog";
import {SrsDisclaimerComponent} from "../legal/srs-disclaimer/srs-disclaimer.component";

@Component({
  selector: 'app-footer2',
  templateUrl: './footer2.component.html',
  styleUrls: ['../../../styles.scss','./footer2.component.scss']
})
export class Footer2Component implements OnInit {

  @Input()
  public showDisclaimer = true;

  constructor(private dialog: MatDialog) {
  }

  ngOnInit(): void {

  }

  openAboutUs(): void {
    this.dialog.open(AboutUsComponent);
  }

  disclaimer(): void {
    this.dialog.open(SrsDisclaimerComponent);
  }

  openTermsOfUse(): void {
    this.dialog.open(TermsOfUseComponent);
  }

  openContactUs(): void {
    this.dialog.open(ContactUsComponent, {
      height: '450px',
      width: '560px'
    });
  }
}
